// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"d3d9f0b9","500":"5564dd00","603":"8737fba7"}[chunkId] + ".chunk.css";
};